import script from "./BuyHttp.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyHttp.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/buy-proxies.css?vue&type=style&index=0&id=1e11cdd9&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e11cdd9"]])

export default __exports__